module.exports = __webpack_public_path__ + "img/illust_number02.84b5ce4.svg";